import axios from 'axios';
import React, { Component } from 'react';
import { GoogleLogin } from 'react-google-login';
import { ThemeProvider } from 'styled-components';

import { exportCSV, getDonations, login } from './util/api';
import { RESULTS_PER_PAGE } from './util/constants';
import { theme } from './util/theme';

import { SiteWrapper, Container } from './components/Shared/Structural';
import { MainWrapper } from './components/MainWrapper/MainWrapper';
import { Footer } from './components/Shared/Footer';

import { LandingPage, Header } from './styled-components';

const GOOGLE_CLIENT_ID =
  '10399156012-17iuct7oe5omj0hhsd4rjri3qhh4924k.apps.googleusercontent.com';

class App extends Component {
  constructor(props) {
    super(props);

    const isLoggedIn = localStorage.getItem('isLoggedIn');

    this.state = {
      loggedIn: JSON.parse(isLoggedIn) || false,
      exporting: false
    };

    // Temporary home for the axios interceptor so we can log out the user if
    // their cookie has expired. This should live in api.js but may require a
    // hint of state management.
    axios.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        if (error.response && error.response.status === 401) {
          this.onLogout();
        } else if (error.response && error.response.data) {
          window.alert(error.response.data.message);
        }
        return error;
      }
    );
  }

  processGoogleResponse = response => {
    // TODO deal with failure
    let token = response.tokenObj && response.tokenObj.id_token;
    login(token).then(() => {
      this.setState(prevState => ({
        loggedIn: !prevState.loggedIn
      }));
      this.onLogin();
    });
  };

  onLogin = () => {
    localStorage.setItem('isLoggedIn', true);
  };

  // The GoogleLogout component does not work if the page has been refreshed
  // so using a custom logout method.
  // https://github.com/anthonyjgrove/react-google-login/issues/130#issuecomment-365886124
  onLogout = () => {
    if (window.gapi) {
      const auth2 = window.gapi.auth2.getAuthInstance();
      if (auth2 != null) {
        auth2
          .signOut()
          .then(auth2.disconnect().then(this.props.onLogoutSuccess));
      }
    }
    this.setState(prevState => ({
      loggedIn: !prevState.loggedIn
    }));

    localStorage.setItem('isLoggedIn', false);
  };

  submitSearch = formState => {
    let query;
    if (formState.search !== undefined) {
      const rawInput = formState.search;
      const components = rawInput.split(/(\d{5})|(\d{5}-\d{4})/);
      const name = components[0].replace(/\W+$/, '');
      const zipcode = components[1];
      query = {
        name: name,
        zipcode: zipcode
      };
    } else {
      query = formState;
    }
    this.setState(
      {
        data: undefined,
        pageIndex: 0,
        query: query
      },
      () => this.search()
    );
  };

  search = () => {
    const offset = this.state.pageIndex * RESULTS_PER_PAGE;
    const limit = RESULTS_PER_PAGE;
    getDonations(this.state.query, limit, offset)
      .then(result => {
        let data = this.state.data || { hits: 0, contributions: [] };
        data.hits = result.hits;
        data.contributions.push(...result.contributions);
        this.setState({ data: data });
      })
      .catch(error => {
        const message =
          'Failed to retrieve search results. Try a different query or contact an admin.';
        window.alert(message, error);
      });
  };

  export = () => {
    // Make sure we can't start more than one export process at a time
    if (!this.state.exporting) {
      this.setState({ exporting: true });
    }
    exportCSV(this.state.query)
      .then(() => {
        this.setState({ exporting: false });
      })
      .catch(error => {
        console.error('Something went wrong exporting CSV', error);
      });
  };

  onPageChange = pageIndex => {
    const oldPageIndex = this.state.pageIndex;
    this.setState({ pageIndex }, () => {
      if (pageIndex > oldPageIndex) {
        // ReactTable doesn't scroll back to the top when the user reaches the
        // bottom of the page and hits the "Next" button. This scrolls them to
        // the top of the table again.
        document.documentElement.scrollTop = document.getElementsByClassName(
          'ReactTable'
        )[0].offsetTop;
        this.search();
      }
    });
  };

  onSortedChange = newSorted => {
    let query = this.state.query;
    query.sort = newSorted[0].id;
    query.direction = newSorted[0].desc ? 'desc' : 'asc';
    this.setState(
      {
        data: undefined,
        pageIndex: 0,
        query: query,
        sorted: newSorted
      },
      () => this.search()
    );
  };

  render() {
    return (
      <ThemeProvider theme={theme}>
        {this.state.loggedIn ? (
          <SiteWrapper>
            <div>
              <Header>
                <button
                  type="button"
                  className="header__logout"
                  onClick={this.onLogout}
                >
                  Log out
                </button>
              </Header>
              <Container>
                <MainWrapper
                  data={this.state.data}
                  onExport={this.export}
                  onPageChange={this.onPageChange}
                  onSortedChange={this.onSortedChange}
                  onSubmit={this.submitSearch}
                  page={this.state.pageIndex}
                  sorted={this.state.sorted}
                />
              </Container>
            </div>
            <Footer />
          </SiteWrapper>
        ) : (
          <LandingPage>
            <div className="landing__image-wrapper">&nbsp;</div>
            <div className="landing__login-wrapper">
              <h1 className="landing__heading">Login</h1>
              <p className="landing__title">Campaign Finance Search</p>
              <GoogleLogin
                className="landing__login"
                clientId={GOOGLE_CLIENT_ID}
                buttonText="Sign in with Google"
                onSuccess={this.processGoogleResponse}
                onFailure={this.processGoogleResponse}
              />
            </div>
          </LandingPage>
        )}
      </ThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js